// TODO: REFACTORING
import React, { useEffect, useState } from 'react';
import { format, parseISO } from 'date-fns';

import Style from './style.module.css';
import './style.css';
import RightArrow from '@images/right.svg';
import Exclamation from '@images/exclamation.svg';
import SpinningWheel from '@components/SpinningWheel';
import FlightStops from './FlightStops';
import AircraftGeneral from './AircraftGeneral';

import useRequest from '@utils/useRequest';
import { apiHost, getAircraftsByModel } from '@utils/constants';
import { capitalizeFirstLetter } from '@utils/functions';
import { translate as t, useCurrentLocale } from '@utils/translate';

const PathCard = ({
  route,
  aircraftDetails,
  modal,
  closeModal,
  flightsLenght,
  cardPosition,
  previous,
  next,
  showSeparator = true,
  showNotice = true,
  showAmenities = true,
}) => {
  const TEXTS = {
    STOP: t('toPlace'),
    OBSERVATIONS: t('observations'),
    EXTRA_OBSERVATIONS: t('extraObservations'),
    WAIT_RESULTS: t('loading'),
  };
  const [aircraft, setAircraft] = useState(
    aircraftDetails ? [aircraftDetails] : null
  ); //AircraftGeneral Details
  const [loading, setLoading] = useState();
  const [error, setError] = useState(false);
  const locale = useCurrentLocale();

  //Datas formating
  const dateFormatted = capitalizeFirstLetter(
    format(
      parseISO(route.departureDatetime || route.flightDatetime),
      "EEEE', 'PPPp",
      {
        locale: locale,
      }
    )
  );

  //Fetch aircraft details
  useEffect(() => {
    const idAircraft = route.aircraft.id;
    if (!aircraft) {
      async function fetchData() {
        setLoading(true);
        try {
          const query =
            apiHost +
            getAircraftsByModel +
            idAircraft +
            '&bringAmenities=1&bringCertifications=1&bringAircraftSize=1';
          //const response = await fetch(query);
          const { data, status } = await useRequest({
            url: query,
            method: 'get',
            useSession: false,
          });
          //const json = await response.json();

          if (status === 200) setAircraft(data.aircrafts);
        } catch (error) {
          setError(true);
        }
        setLoading(false);
      }
      if (idAircraft !== undefined) {
        fetchData();
      }
    }
  }, []);
  return (
    <div className={[Style.pathCard, 'pathCard'].join(' ')}>
      <div
        className={
          modal
            ? [Style.cardHeader, Style.cardHeaderModal].join(' ')
            : Style.cardHeader
        }
      >
        <p className={Style.departureCity}>
          {route.originSpot.address.city.name}
        </p>
        <img src={RightArrow} alt={TEXTS.STOP} className={Style.arrow} />
        <p className={Style.arriveCity}>
          {route.destinationSpot.address.city.name}
        </p>
        <p className={Style.date}>{dateFormatted}</p>
        {modal && flightsLenght > 1 && (
          <div className={Style.buttons}>
            <button
              disabled={cardPosition === 0}
              className={Style.prevButton}
              onClick={previous}
            >
              <div className={Style.prevArrow}></div>
            </button>
            <button
              disabled={flightsLenght === cardPosition + 1}
              className={Style.nextButton}
              onClick={next}
            >
              <div className={Style.nextArrow}></div>
            </button>
          </div>
        )}
      </div>
      <div className={modal ? Style.stopsModal : Style.stops}>
        <FlightStops {...route} />
        {showNotice && route.notice && (
          <div className={Style.notice}>
            <img
              src={Exclamation}
              alt={TEXTS.OBSERVATIONS}
              className={Style.noticeExclamation}
            />
            <p>
              <strong>{TEXTS.OBSERVATIONS}: </strong>
              {route.notice}
            </p>
          </div>
        )}
      </div>
      <hr />
      {aircraft && !loading ? (
        <AircraftGeneral
          aircraftGallery={aircraft[0].pictures}
          aircraftDescription={{
            aircraftDescription: aircraft[0],
            avaliation: aircraft[0].model.rate,
          }}
          aircraftCertifications={aircraft[0].certifications}
          aircraftAmenities={aircraft[0].amenities}
          isModal={modal}
          showAmenities={showAmenities}
        />
      ) : (
        <div className={Style.loadingAircrafts}>
          <div className={Style.mainMessage}>{TEXTS.WAIT_RESULTS}</div>
          <SpinningWheel className="load" />
        </div>
      )}
      {modal ? (
        <div />
      ) : (
        showSeparator && <footer className={Style.pathSeparator}></footer>
      )}
    </div>
  );
};

export default PathCard;
